import React, { createContext, useContext, useState } from "react";

interface CityContextType {
    selectedCity: string | undefined;
    setSelectedCity: (city: string) => void;
}

const CityContext = createContext<CityContextType | undefined>(undefined);

export function CityProvider({ children }: { children: React.ReactNode }) {
    const [selectedCity, setSelectedCity] = useState<string>();

    return (
        <CityContext.Provider value={{ selectedCity, setSelectedCity }}>
            {children}
        </CityContext.Provider>
    );
}

export function useCity() {
    const context = useContext(CityContext);
    if (context === undefined) {
        throw new Error("useCity must be used within a CityProvider");
    }
    return context;
} 